import { useStartProcess } from "@/hooks/ai-tool-process/use-start-process";
import { useTextToSpeechProgressContext } from "@/components/pages/text-to-speech/components/providers/text-to-speech-progress-provider";
import { textToSpeechSessionStorage } from "@/services/storage/text-to-speech-session-storage";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { LicenseName } from "@/data/license.data";

export type TextToSpeechConfig = {
  text: string;
  voice: string;
  language: string;
};

const startTextToSpeechConfigCreator = (
  textToSpeechConfig: TextToSpeechConfig,
) => {
  return {
    createConfigFormData: (formData: FormData) => {
      formData.append("text", textToSpeechConfig.text);
      formData.append("voice", textToSpeechConfig.voice);
      formData.append("language", textToSpeechConfig.language);
    },
  };
};

export const useStartTextToSpeech = () => {
  const progressContext = useTextToSpeechProgressContext();
  const { showModal } = useGlobalModalContext();
  const showLimitedModal = (licenseName: LicenseName) =>
    showModal({
      type: "text-to-speech-count-limited_modal",
      props: {
        licenseName: licenseName,
      },
    });

  const { startAiProcess } = useStartProcess(
    (config: TextToSpeechConfig) => startTextToSpeechConfigCreator(config),
    textToSpeechSessionStorage.pendingConfigStorage,
    "/api/text-to-speech/file",
    progressContext,
    showLimitedModal,
  );

  return { startTextToSpeech: startAiProcess };
};
